<template>
    <div>
        <h1>Atoms</h1>
        <ds-atoms-list />
    </div>
</template>
